/* eslint-disable indent */

const useEventData = () => {
  const convert = data => {
    const valueIsObject = ['country', 'industry']

    const hasValue = value =>
      Array.isArray(value) ? value.length > 0 : Boolean(value)

    const getDataKey = key => (key === 'industryOther' ? 'industry' : key)

    const getDataValue = (key, value) =>
      !hasValue(value)
        ? undefined
        : valueIsObject.includes(key)
        ? value.label
        : value

    const converted = Object.entries(data).reduce(
      (acc, [key, value]) => ({
        ...acc,
        [getDataKey(key)]: getDataValue(key, value)
      }),
      {}
    )
    return converted
  }

  return convert
}

export default useEventData
